import script from "./LoginEmail.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginEmail.vue?vue&type=script&setup=true&lang=js"

import "./LoginEmail.vue?vue&type=style&index=0&id=60fc529f&lang=css"

const __exports__ = script;

export default __exports__